import FormattedMessage from 'I18n/components/FormattedMessage';
import { Section, SectionHeader } from './Section';
import ArticlesList from './ArticlesList';
import { TRENDING, HELPFUL } from './constants/knowledgeBaseRecommendationTypes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RecommendedArticlesList = ({
  articles,
  coloring,
  onArticleClick,
  hideSubtitle,
  kbRecommendationType = TRENDING,
  disabled = false
}) => {
  if (!(articles !== null && articles !== void 0 && articles.length)) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Section, {
    children: [/*#__PURE__*/_jsx(SectionHeader, {
      children: kbRecommendationType === HELPFUL ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-visitor-experience-components.knowledgeBase.highestRated.title"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-visitor-experience-components.knowledgeBase.mostViewed.title"
      })
    }), /*#__PURE__*/_jsx(ArticlesList, {
      items: articles,
      coloring: coloring,
      onArticleClick: onArticleClick,
      hideSubtitle: hideSubtitle,
      disabled: disabled
    })]
  });
};
RecommendedArticlesList.displayName = 'RecommendedArticlesList';
export default RecommendedArticlesList;